import React from 'react'
import type { Translation } from '../../i18n'
import { serif, cream } from './tokens'

type Props = { l: Translation['landing']['lifestyle'] }

export const LifestyleStrip: React.FC<Props> = ({ l }) => (
  <div className="grid md:grid-cols-2 h-[420px] overflow-hidden">
    {([
      { src: '/apps/ca/img/catalog/lifestyle_1.jpg', caption: l.caption1 },
      { src: '/apps/ca/img/catalog/lifestyle_2.jpg', caption: l.caption2 },
    ] as const).map(({ src, caption }) => (
      <div key={src} className="relative overflow-hidden group">
        <img
          src={src}
          alt=""
          aria-hidden
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
        />
        <div
          className="absolute bottom-0 inset-x-0 p-8 text-[1.1rem] italic"
          style={{ background: 'linear-gradient(transparent, rgba(61,42,10,0.7))', fontFamily: serif, color: cream }}
        >
          {caption}
        </div>
      </div>
    ))}
  </div>
)
